import GuidePerformance from 'models/guide_performance';
import createConverter from './lib/create_converter';

export default createConverter(GuidePerformance);
